import { create } from "zustand";

interface CustomRequestState {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

export const CustomRequestStore = create<CustomRequestState>((set) => ({
  isOpen: false,
  setOpen: (open: boolean) => set({ isOpen: open }),
}));
